import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
import styles from "./Stores.module.scss";
import { useEffect, useState } from "react";
import { SellersService } from "../../services/sellers.service";
import {
  CountriesDataType,
  SellersDataType,
  StrorecategoryDataType,
} from "../../interface/site.interface";
import Spinner from "../../components/shared/spinner/Spinner";
import { CountriesService } from "../../services/countries.service";
import { Base_Url } from "../../constants/base_url";
import MainButton from "../../components/shared/button/MainButton";
import { useSite } from "../../context/TranslationContext";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const Stores = () => {
  const [activeCountryIndex, setActiveCountryIndex] = useState<number | null>(
    null
  );
  const language = useSelector((state: RootState) => state.language.language);

  const [activeCategoryIndex, setActiveCategoryIndex] = useState<number | null>(
    null
  );
  const [sellers, setSellers] = useState<SellersDataType[]>();
  const [catId, setCatId] = useState<string | null>(null);
  const [countryId, setCountryId] = useState<string | null>(null);
  const [countries, setCountries] = useState<CountriesDataType[]>([]);
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null);
  const { data } = useSelector((state: RootState) => state.translationData);
  const [storeCategory, setStoreCategory] =
    useState<StrorecategoryDataType[]>();
  const [loading, setLoading] = useState<boolean>(false);

  // categories
  useEffect(() => {
    setLoading(true);
    SellersService.getAllStoreCategory()
      .then((res) => setStoreCategory(res?.data?.original))
      .finally(() => setLoading(false));
  }, [language]);

  // countries
  useEffect(() => {
    CountriesService.getAllCountries().then((response) =>
      setCountries(response?.data?.original)
    );
  }, [language]);

  const handleCountryClick = (index: number, countryId: number) => {
    setActiveCountryIndex(index);
    setCountryId(countryId.toString());
  };

  // stores
  useEffect(() => {
    const fetchSellers = async () => {
      if (catId === null || countryId === null) {
        setLoading(true);
      }
      try {
        const res = await SellersService.getAllSellers(catId, countryId);
        setSellers(res?.data?.original?.data);
        setNextPageUrl(res?.data?.original?.next_page_url);
      } finally {
        setLoading(false);
      }
    };

    fetchSellers();
  }, [catId, countryId, language]);

  const fetchSellers = (url?: string) => {
    const fetchUrl =
      url ||
      `https://colibri.az/api/get-seller?category_id=${catId}&country_id=${countryId}`;
    SellersService.getSellersByUrl(fetchUrl).then((res) => {
      const data = res?.data?.original;
      setSellers((prev) => [...(prev || []), ...data.data]);
      setNextPageUrl(data.next_page_url);
    });
  };

  return (
    <div id={styles.stores_page}>
      <TitleUpdater
        title={
          data?.colibri && data?.stores
            ? `${data?.colibri} | ${data?.stores}`
            : "Colibri"
        }
      />
      <div className="container">
        {loading ? (
          <Spinner />
        ) : (
          <div className={styles.stores}>
            <h1 className={styles.section_title}>{data?.stores}</h1>
            <div className={styles.name_buttons}>
              <div className={styles.countries_name}>
                {countries?.map((country, index) => (
                  <button
                    key={index}
                    className={`${styles.country_name} ${
                      activeCountryIndex === index ? styles.active_btn : ""
                    }`}
                    onClick={() => handleCountryClick(index, country.id)}
                  >
                    <img
                      src={`${Base_Url}${country.image}`}
                      alt={country.title}
                    />
                    <p>{country.title}</p>
                  </button>
                ))}
              </div>
            </div>
            <div className={styles.store_names}>
              <Swiper
                className={styles.mySwiper}
                slidesPerView={"auto"}
                spaceBetween={12}
                breakpoints={{
                  1200: {
                    slidesPerView: 6.4,
                  },
                  1024: {
                    slidesPerView: 6.4,
                  },
                  994: {
                    slidesPerView: 2.2,
                  },
                  576: {
                    slidesPerView: 2,
                  },
                  0: {
                    slidesPerView: 2,
                  },
                }}
              >
                {storeCategory?.map((st, idx) => {
                  return (
                    <SwiperSlide key={idx} className={styles.swiperSlide}>
                      <div
                        className={`${styles.name_btn} ${
                          activeCategoryIndex === idx ? styles.active_btn : ""
                        }`}
                        onClick={() => {
                          console.log(st.id);

                          setActiveCategoryIndex(idx);
                          setCatId(st.id.toString());
                        }}
                      >
                        {st.title}
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
            {sellers?.length !== 0 ? (
              <div className={styles.product_section}>
                {sellers?.map((product, idx) => (
                  <div
                    key={idx}
                    className={`${styles.product_card} ${
                      Math.floor(idx / 6) % 2 === 0
                        ? styles.top_row
                        : styles.bottom_row
                    }`}
                  >
                    {product.img && product.url ? (
                      <a
                        href={product.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={`https://backend.colibri.az//${product.img}`}
                          alt=""
                          className={styles.product_image}
                        />
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.no_stores}>{data?.store_not_found}</div>
            )}
          </div>
        )}
        {nextPageUrl && (
          <div className={styles.load_more_wrapper}>
            <MainButton
              text={data?.learn_more}
              onClick={() => fetchSellers(nextPageUrl)}
              className={styles.load_more_btn}
            />
          </div>
        )}
      </div>
      <MobileAppSection />
    </div>
  );
};

export default Stores;
